import createPersistedState from 'use-persisted-state';

export const useLocalStorage = (key, initialValue) => {
  return createPersistedState(key)(initialValue);
};
